<div style="display: flex; justify-content: flex-start">
  <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 57%">
    <p class="share">Invite People</p>
    <span style="font-weight: 600; font-size: 16px;"> Copy Link</span>
    <!-- Shared app-copy-link-field owns the clipboard copy + "Link copied!"
           tooltip; the success toast stays here via (copied). -->
    <app-copy-link-field [value]="flyshareInviteLink" (copied)="onLinkCopied()"></app-copy-link-field>
    <div class="separator" style="margin-right: 22px;">&nbsp;&nbsp; or &nbsp;&nbsp;</div>
    <span class="form-span">Send from:</span>
    <span style="color: #4F4F4F; font-weight: 300; font-size: 14px;">We recommend using a name that the recipient will
      recognize</span>
    <form [formGroup]="form" (ngSubmit)="share()">
      <!-- M1: was a `<table cellspacing="0">` whose `<td>`s had no padding —
               Material's form-field padding used to fake the gutter, vng-input
               has none, so the two inputs butted together. -->
      <div class="name-row">
        <vng-input label="First Name" placeholder="First Name" class="text-capitalize name-row__field"
          [formControl]="form.controls['first_name']" [error]="
                (form.controls['first_name'].dirty || form.controls['first_name'].touched) ? (
                  form.controls['first_name'].hasError('required') ? 'First name is required.' :
                  form.controls['first_name'].hasError('pattern') ? 'Numbers not allowed.' :
                  form.controls['first_name'].hasError('maxlength') ? 'Max length is 12.' : ''
                ) : ''
              "></vng-input>
        <vng-input label="Last Name" placeholder="Last Name" class="text-capitalize name-row__field"
          [formControl]="form.controls['last_name']" [error]="
                (form.controls['last_name'].dirty || form.controls['last_name'].touched) ? (
                  form.controls['last_name'].hasError('required') ? 'Last name is required.' :
                  form.controls['last_name'].hasError('pattern') ? 'Numbers not allowed.' :
                  form.controls['last_name'].hasError('maxlength') ? 'Max length is 12.' : ''
                ) : ''
              "></vng-input>
      </div>
      <span class="form-span">Send Email to<span style="color: #FF0000;">*</span>:</span>

      <vng-form-field label="Emails" class="example-chip-list"
        [error]="invalidEmail() ? 'Please enter a valid email address' : ''">
        <div class="chip-list-wrapper">
          <vng-chip *ngFor="let email of emails" [removable]="true" (removed)="remove(email)">{{ email }}</vng-chip>
          <input #emailInput type="text" class="chip-input fly-msg-ignore" aria-label="Emails"
            placeholder="Email (Separate with comma)" (keydown.enter)="addFromInput(); $event.preventDefault()"
            (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" (blur)="addFromInput()" (paste)="onPaste($event)" />
        </div>
      </vng-form-field>
      <span class="form-span">Personalized Message <span style="color: #757575; font-weight: 400; margin-bottom: 8px;">
          (Optional)</span></span>
      <vng-textarea placeholder="Personalized Message" [resize]="'none'" [formControl]="form.controls['message']"
        class="message-textarea"></vng-textarea>
    </form>
    <button onclick="this.blur()" style="margin-top: 12px; width: 150px;" (click)="share()" vng-button variant="primary"
      [disabled]="!emails || emails.length < 1 || form.controls['first_name'].hasError('required') || form.controls['last_name'].hasError('required') || form.controls['last_name'].hasError('pattern') || form.controls['first_name'].hasError('pattern')|| form.controls['first_name'].hasError('maxlength') || form.controls['last_name'].hasError('maxlength') || invalidEmail()">
      Invite
    </button>
  </div>

  <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 43%; background-color: #F5F5F5;">
    <!-- M1: the gray column bleeds into the dialog panel's own 1rem padding so
           it reaches the panel edge on three sides. It used to be a fixed 375px
           box with `margin: -24px 0` (Material's old 24px padding, vertical
           only), which overflowed the 43% column and pushed the close button
           past the panel's right edge, where `overflow: auto` clipped it. -->
    <div style="background-color: #F5F5F5; height: -webkit-fill-available; margin: -1rem -1rem -1rem 0;">
      <div style="display: flex; justify-content: flex-end; padding: 8px 12px 0 0; background-color: #F5F5F5;">
        <app-dialog-close-button class="close-button" [size]="30" [compact]="true" color="black"
          (closed)="close()"></app-dialog-close-button>
      </div>

      <div
        style="display: flex; flex-direction: column; justify-content: center; align-items: center; background-color: #F5F5F5; padding-left: 10px; width: 100%; margin-top: 8rem;">
        <div style="text-align: center; ">
          <img width="150" height="120" src="../../../../assets/images/handshake.gif" alt="Handshake Gif">
          <p>{{inviteCounter}} people signed up</p>
        </div>

        <div class="radio-group"
          style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; flex: 1 1 100%; max-height: 60%">
          <!-- Each milestone is its own single-item vng-radio-group: vng-radio-button's
                 `checked` is only ever driven by a wrapping group's CVA value (no standalone
                 [checked] input, unlike mat-radio-button which the original relied on via
                 `checked="{{}}"` attribute interpolation) — see cheatsheet #23/new gotcha. -->
          <vng-radio-group [ngModel]="!!firstPersonSignedUp" class="radio-button-group">
            <vng-radio-button class="radio-button" [value]="true" [disabled]="!firstPersonSignedUp"
              style="text-align: start !important;">
              <span>Get Unlimited FlyCuts</span>
              <span style="display: block; text-align: start; font-weight: normal;">1st person to sign up</span>
              <hr [ngClass]="!!firstPersonSignedUp ? 'radio-completed' : 'radio-not-completed'"
                style="height: 32px; margin-top: -11px; margin-bottom: -21px;">
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!secondPersonSignedUp" class="radio-button-group">
            <vng-radio-button class="radio-button" [value]="true" [disabled]="!secondPersonSignedUp"
              style="text-align: start !important;">
              <span>Get Unlimited Characters</span>
              <span style="display: block; text-align: start; font-weight: normal;">2nd person to sign up</span>
              <hr [ngClass]="!!secondPersonSignedUp ? 'radio-completed' : 'radio-not-completed'"
                style="height: 44px; margin-top: -11px; margin-bottom: -33px;">
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!thirdPersonSignedUp" class="radio-button-group">
            <vng-radio-button class="radio-button" [value]="true" [disabled]="!thirdPersonSignedUp"
              style="text-align: start !important;">
              <span>Get Access to One Additional <br> FlyCuts Category</span>
              <span style="display: block; text-align: start; font-weight: normal;">3rd person to sign up</span>
              <hr [ngClass]="!!thirdPersonSignedUp ? 'radio-completed' : 'radio-not-completed'"
                style="height: 42px; margin-top: -21px; margin-bottom: -21px;">
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!fourthPersonSignedUp" class="radio-button-group">
            <vng-radio-button class="radio-button" [value]="true" [disabled]="!fourthPersonSignedUp"
              style="text-align: start !important;">
              <span>Get Access to All FlyPlates</span>
              <span style="display: block; text-align: start; font-weight: normal;">4th person to sign up</span>
            </vng-radio-button>
          </vng-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>